import { motion } from "framer-motion";
import increse from "../Images/incrase.png";
import access from "../Images/access.png";
import enhance from "../Images/enhance.png";
import faster from "../Images/fastertime.png";
import market from "../Images/market.png";
import cost from "../Images/cost.png";

const steps = [
  {
    id: 1,
    title: "Increased Revenue",
    description:
      "Expand your service offerings and create new revenue streams through our partnership.",
    iconImg: increse,
    color: "bg-pink-500",
    textColor: "text-[#FF4FE4]",
  },
  {
    id: 2,
    title: "Access to Expertise",
    description:
      "Leverage our technical expertise and industry knowledge to deliver better solutions.",
    iconImg: access,
    color: "bg-orange-400",
    textColor: "text-[#FF927B]",
  },
  {
    id: 3,
    title: "Enhanced Credibility",
    description:
      "Strengthen your market position by partnering with a trusted IT solutions provider.",
    iconImg: enhance,
    color: "bg-teal-400",
    textColor: "text-[#9BFFE9]",
  },
  {
    id: 4,
    title: "Faster Time to Market",
    description:
      "Accelerate project delivery by combining our resources and capabilities.",
    iconImg: faster,
    color: "bg-green-400",
    textColor: "text-[#B7E333]",
  },
  {
    id: 5,
    title: "Market Expansion",
    description:
      "Reach new markets and customer segments through our established networks.",
    iconImg: market,
    color: "bg-purple-500",
    textColor: "text-[#CA55FC]",
  },
  {
    id: 6,
    title: "Cost Efficiency",
    description:
      "Reduce operational costs by sharing resources and leveraging economies of scale.",
    iconImg: cost,
    color: "bg-red-500",
    textColor: "text-[#D72D2D]",
  },
];

// Duplicate elements for infinite effect
const marqueeSteps = [...steps, ...steps];

export default function PartnershipModels() {
  return (
    <div className="flex relative flex-col   overflow-hidden  text-white">
      {/*  */}
      <div className="p-5 md:ml-10 md:mt-5 ">
        <button className="w-[270px] h-[60px] relative rounded-full bg-[#432DD7] ">
          Partnership Benefits
        </button>
        <h2
          className="p-2 text-[40px] font-[700] text-black relative text-justify"
          style={{ fontFamily: "PT Sans" }}
        >
          Access innovative
        </h2>
        <h2 className="p-2 text-[40px] font-[400] text-[#432DD7] relative font-[Allison] text-justify">
          solutions tailored to your needs.
        </h2>
        <h2 className="p-2 text-[16px] font-[400] text-[#62739E] max-w-[1200px] text-justify">
          Discover the advantages of partnering with Godhani Technology and
          unlock endless growth opportunities. Our expertise in IT solutions,
          digital transformation, and innovation ensures that your business
          stays ahead in a competitive market. We offer flexible partnership
          models tailored to meet your unique business needs, providing scalable
          and cost-effective solutions.
        </h2>
      </div>
      {/* Infinite Scrolling Cards */}
      <div className="w-full overflow-hidden relative mt-10">
        <motion.div
          className="flex gap-8"
          animate={{ x: ["0%", "-100%"] }} // Move content infinitely
          transition={{
            ease: "linear",
            duration: 15,
            repeat: Infinity,
          }}
        >
          {[...marqueeSteps, ...marqueeSteps].map((step, index) => (
            <div
              key={index}
              className="min-w-[280px] md:min-w-[320px] lg:min-w-[350px] flex flex-col p-6 rounded-lg  border border-gray-300"
            >
              {/* Dots Above Cards */}
              <div className="absolute top-[-16px] left-1/2 transform -translate-x-1/2 w-4 h-4 bg-gray-600 rounded-full"></div>

              {/* Colored Icon Background */}

              <img
                src={step.iconImg}
                alt={step.title}
                className="w-20 h-20 object-contain"
              />

              {/* Title with Matching Color */}
              <h3
                className={`mt-4 text-xl font-bold ${step.textColor}`}
                style={{ fontFamily: "PT Sans" }}
              >
                {step.title}
              </h3>

              {/* Description */}
              <p className="mt-2 leading-relaxed text-black max-w-[280px] break-words text-wrap text-left">
                {step.description}
              </p>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
}
